import React from 'react';

import PropTypes from 'prop-types';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { SummaryItemCount, SummaryItemLabel, SummaryItemMain, SummaryMain } from './css';

const PowerFleetTracker = ({ hardwareList, tracker }) => {
  const {
    iotOrderDetailsSection: {
      labelTotalNumberOf,
      labelColdChainMonitor,
      labelTotalCCM
    }
  } = useLocalizedStringsContext();

  const {
    fleetTrackerRateplanTotal
  } = tracker;

  return (
    <div>
      <h4>{labelColdChainMonitor}</h4>
      <SummaryMain>
        <SummaryItemMain>
          <SummaryItemLabel>{labelTotalCCM}</SummaryItemLabel>
          <SummaryItemCount>{fleetTrackerRateplanTotal}</SummaryItemCount>
        </SummaryItemMain>
        {Object.keys(hardwareList).map(hardwareName => (
          <SummaryItemMain>
            <SummaryItemLabel>
              {labelTotalNumberOf}
              {hardwareName}
            </SummaryItemLabel>
            <SummaryItemCount>{hardwareList[hardwareName]}</SummaryItemCount>
          </SummaryItemMain>
        ))}
      </SummaryMain>
    </div>
  );
};

PowerFleetTracker.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    fleetTrackerRateplanTotal: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default PowerFleetTracker;
